import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle, ArrowRight, Pill } from "lucide-react";

export const Route = createFileRoute("/ai/drug-interactions")({
  component: DrugInteractionsPage,
});

function DrugInteractionsPage() {
  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <Pill className="h-5 w-5" /> Drug Interactions
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">Vérification automatique des interactions médicamenteuses</p>
      </div>

      <Card>
        <CardContent className="p-6 text-sm text-muted-foreground">
          <p>Le module de vérification est intégré au flux d'ordonnance. À la soumission d'une prescription, le système interroge automatiquement la base de données d'interactions et signale les conflits potentiels.</p>
          <Button asChild className="mt-4">
            <Link to="/prescription">Ouvrir Ordonnance <ArrowRight className="h-3.5 w-3.5 ml-1" /></Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
